import { combineReducers } from "redux";
import selectedItemSlice from "../slice/take-order-slice/selected-item-slice";
import cartSlice from "../slice/take-order-slice/cart-slice";
import order from "../slice/take-order-slice/order-slice";
import  selectedCustomer  from "../slice/take-order-slice/selected-customer-slice";
import  booking  from "../slice/take-order-slice/booking-slice";
import  deliveryInfo  from "../slice/take-order-slice/delivery-slice";
import preOrders from "../slice/take-order-slice/preorders-slice";
import homePageItems from "../slice/take-order-slice/home-page-items-slice";


const takeOrderReducer = combineReducers({
  selectedItem: selectedItemSlice,
  cart: cartSlice,
  order: order,
  selectedCustomer: selectedCustomer,
  booking: booking,
  delivery:deliveryInfo,
  preOrders: preOrders,
  homePageItems: homePageItems
});

export default takeOrderReducer;
